<template>
  <div class="home_container">
      <header class="home_header">
            <img :src="avatar" alt="">
            <div>
              <div>{{ nickName }}</div>
              <div>学生：<span :style="{'pointer-events': studentId ? 'none' : ''}" @click="onBindingJump()">{{ studentId ? studentName : '未绑定'}}</span><span v-if="studentId" class="jiebang" @click="unBind">解绑</span></div>
            </div>
      </header>
      <main class="home_main"> 
            <section class="menubox">
                <div class="grid_item" v-for="menu in menus" :key="menu.id" @click="onMenuJump(menu.url)">
                    <img :src="menu.icon" alt="">
                    <div>{{ menu.title }}</div>
                </div>
            </section>
            <div class="zixun">有问题请咨询在线AI眼科专家</div>
      </main>
  </div>
</template>

<script>
import { unbindStudentIdApi } from "@/api/studentBinding.js";
import { getNickName, getName, getStudentId } from "@/utils/auth.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      menus: [
        {
          id: 2,
          title: "家长打卡",
          icon: require("../../assets/img/home/daka.png"), // user-o
          // url: ""
          url: "Clock"
        },
        {
          id: 1,
          title: "AI视力报告",
          icon: require("../../assets/img/home/baogao.png"), //'question-o',
          url: "ReportList"
        },
        {
          id: 0,
          title: "视力档案",
          icon: require("../../assets/img/home/dangan.png"), //'question-o',
          url: "Record"
        },
        {
          id: 3,
          title: "防控知识",
          icon: require("../../assets/img/home/fangkong.png"), //'comment-circle-o',
          url:
            "https://mp.weixin.qq.com/mp/homepage?__biz=MzA3MjM3NTMxNA==&hid=9&sn=b053dcee41ad35b5264253a5bc1ef2f3&scene=1&devicetype=iOS13.1.3&version=17000827&lang=zh_CN&nettype=WIFI&ascene=7&session_us=gh_60ce5e5255b5&fontScale=100&wx_header=1"
        },
        {
          id: 4,
          title: "护眼大讲堂",
          icon: require("../../assets/img/home/jiangtang.png"), //'service-o',
          url: "Lecture"
        },
        {
          id: 5,
          title: "视力自测",
          icon: require("../../assets/img/home/zice.png"), //'browsing-history-o',
          url: "Test"
        },
        {
          id: 6,
          title: "问卷调查",
          icon: require("../../assets/img/home/wenjuan.png"), //'todo-list-o',
          url: "https://www.wjx.cn/vj/OMNVxdu.aspx"
        },
        {
          id: 8,
          title: "视健康评估",
          icon: require("../../assets/img/home/pinggu.png"), //'smile-comment-o',
          url: "https://seex.dev.iouou.cn/Wechat/VisionQuetionnaire/about"
        },
        {
          id: 9,
          title: "政策信息",
          icon: require("../../assets/img/home/zhengce.png"), //'smile-o',
          url:
            "http://www.nhc.gov.cn/jkj/s5898bm/201910/c475e0bd2de444379402f157523f03fe.shtml" //https://demo2.qpsc365.com/wechat/index.html?t=1572873866390#/daily
        }
      ]
    };
  },
  mounted() {
    console.log(123)
  },
  methods: {
    //菜单跳转->外链或路由
    onMenuJump(name) {
      if (name.indexOf("http") == 0) {
        location.href = name;
      } else if (name.length == 0) {
        this.$dialog.alert({ message: "即将更新，敬请期待！" });
      } else {
        this.$router.push({ name });
      }
    },
    onBindingJump() {
      this.$router.push({ name: "StudentBinding" });
    },
    unBind() {
      this.$dialog
        .confirm({
          title: "确认要解绑吗？"
        })
        .then(() => {
          unbindStudentIdApi({
            studentId: this.studentId
          }).then(res => {
             this.$store.commit('app/SET_STUDENTID','')
             this.$store.commit('app/SET_NAME','')
             this.$store.commit('app/SET_GENDER','')
             this.$toast({
                type: "success",
                message: "解绑成功",
                onClose: () => {
                    // window.location.reload();
                }
             });
          });
        });
    }
  },
  computed:{
    ...mapState('app',['nickName','studentName','studentId','avatar'])
  }
};
</script>
<style scoped>
.home_container {
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

.home_header {
  height: 0.64rem;
  padding: 0.18rem 0 0.48rem 0.28rem;
  border-radius: 0 0 0.2rem 0.2rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: url(../../assets/img/home/top_daka.png) no-repeat;
  background-size: 100% 100%;
}

.home_header > img:first-child {
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.15rem;
  border: 0.02rem solid #ffffff;
  border-radius: 50%;
}

.home_header > div:nth-child(2) {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 400;
  line-height: 0.16rem;
}

.home_header > div:nth-child(2) > div:first-child {
  margin-top: 0.12rem;
}

.home_header > div:nth-child(2) > div:last-child {
  margin-bottom: 0.12rem;
}

.home_main {
  width: 100%;
  position: absolute;
  top: 1.04rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.menubox {
  width: calc(100vw - 0.5rem);
  margin: 0 auto;
  padding: 0.25rem 0.15rem;
  background-color: #ffffff;
  border-radius: 0.2rem;
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-template-rows: 1.18rem;
  grid-row-gap: 0.2rem;
}

.grid_item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.grid_item > div:nth-child(2) {
  margin-top: 0.1rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #707070;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.jiebang {
  margin-left: 0.3rem;
}

.zixun {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #3bd3c1;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  margin: 0.2rem 0;
}
</style>
